import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import {
  CustomerBalance,
  CustomerUser,
  Order,
  type CustomerLedgerUpdateTypeEnum,
  type DetailsDrawerEntity,
} from '@talos/kyoko';
import { ANALYTICS_WIDTH } from '../../../styles/dimensions';
import type { OMSView } from '../OMSView';

const initialState: DetailsDrawerState = {
  width: 560,
  entity: undefined,
  getDetailsHref: undefined,
  onClickTransaction: undefined,
  previousView: undefined,
};

const detailsDrawerSlice = createSlice({
  name: 'detailsDrawer',
  initialState,
  reducers: {
    openDetails: (
      state,
      action: PayloadAction<{
        entity: DetailsDrawerState['entity'];
        getDetailsHref?: DetailsDrawerState['getDetailsHref'];
        onClickTransaction?: DetailsDrawerState['onClickTransaction'];
        previousView?: OMSView;
      }>
    ) => {
      const { entity, getDetailsHref, onClickTransaction, previousView } = action.payload;
      state.entity = entity;
      state.getDetailsHref = getDetailsHref;
      state.onClickTransaction = onClickTransaction;
      state.previousView = previousView;
      state.width = 560;
      if (entity instanceof Order) {
        state.width = ANALYTICS_WIDTH;
      }
      if (entity instanceof CustomerBalance) {
        state.width = 675;
      }
      if (entity instanceof CustomerUser) {
        state.width = 650;
      }
    },
  },
});

export const { openDetails } = detailsDrawerSlice.actions;

export interface DetailsDrawerState {
  width: number;
  entity?: DetailsDrawerEntity;
  previousView?: OMSView;
  getDetailsHref?: (entity: DetailsDrawerEntity) => string | undefined;
  onClickTransaction?: (customerBalance: CustomerBalance, transactionType?: CustomerLedgerUpdateTypeEnum) => void;
}

export const detailsDrawerSliceReducer = detailsDrawerSlice.reducer;
